import type { ButtonProps } from '@packages/shared';
import { Button, Link } from '@packages/shared';
import { ComponentTypes } from '../../../interfaces';
import { buildLinkWithArguments } from '../../utils';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import type { LinkByButtonType } from './types';

export const LinkByButton = ({ data }: { data: LinkByButtonType }) => {
  const {
    field_link: link,
    field_text: text,
    field_layout: color,
    field_css_class: cssClass,
    behavior_settings: behaviorSettings,
  } = data;

  const finalColor = (
    color && !color.match(/base|greyDark|greyLight/g) ? color : undefined
  ) as ButtonProps['color'];

  return (
    <Button
      LinkComponent={Link}
      href={buildLinkWithArguments(link, data)}
      color={finalColor}
      className={cssClass}
      {...(behaviorSettings &&
        'paragraph_size' in behaviorSettings && {
          size: behaviorSettings.paragraph_size.behaviorSize,
        })}
    >
      {text}
    </Button>
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.LinkByButton]: LinkByButton });
